module.exports = __webpack_public_path__ + "static/img/yiqingNewMiddle.5ea8b16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yiqingNewMiddle.jpg
// module id = W0zB
// module chunks = 0